var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoiceIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.657 3.125c0-1.036.84-1.875 1.875-1.875h13.25c1.036 0 1.875.84 1.875 1.875v15.75c0 1.035-.84 1.875-1.875 1.875H4.532a1.875 1.875 0 01-1.875-1.875V3.125zm2 .125v15.5h13V3.25h-13z",
    fill: "#7C8193"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.094 9.188a1 1 0 011-1h6.125a1 1 0 010 2H8.094a1 1 0 01-1-1zM7.094 12.813a1 1 0 011-1h3.062a1 1 0 110 2H8.094a1 1 0 01-1-1z",
    fill: "#7C8193"
  })));
}
export default __webpack_public_path__ + "media/images/invoiceIcon-d9fe9b11.svg";
export { SvgInvoiceIcon as ReactComponent };